import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";   // <-- ADD THIS

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDmHeC-2w2HACqjXFqaCt-sydX9DaI6_rY",
    authDomain: "project-summary-dashboard.firebaseapp.com",
    projectId: "project-summary-dashboard",
    storageBucket: "project-summary-dashboard.firebasestorage.app",
    messagingSenderId: "555335856204",
    appId: "1:555335856204:web:f175456bf3a203868f84e9",
    measurementId: "G-360SBM185G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const analytics = getAnalytics(app);

// ✅ ADD THIS
const db = getFirestore(app);

// Export everything including analytics + db
export { auth, googleProvider, signInWithPopup, signOut, analytics, db };
